/**
 * Unified share-card theme set.
 *
 * Used by ShareModal (chat), ShareReflectionModal, and ShareDYKModal
 * so the palette is consistent everywhere. (Bible reader's ShareVerseModal
 * is the explicit exception — it has its own verse-specific themes.)
 *
 * Each theme provides:
 *   bg         — card background (solid for chat/dyk; reflection uses as base)
 *   text       — primary body text colour
 *   accent     — brand accent (links, buttons, scripture chip text)
 *   secondary  — muted/secondary text
 *   border     — hairline divider and tag-chip border colour
 *   swatch     — [outerColor, innerColor] for the theme-picker swatch
 *   topicColor — large heading colour (mostly an accent tint)
 *   tagBg      — scripture-tag background (transparent-ish wash)
 */
export const SHARE_THEMES = [
  {
    key: 'classic',
    label: 'Classic',
    bg: '#FFFFFF',
    text: '#1a1a2e',
    accent: '#6366f1',
    secondary: '#64748b',
    border: '#e2e8f0',
    topicColor: '#3730a3',
    tagBg: '#eef2ff',
    swatch: ['#FFFFFF', '#6366f1'],
  },
  {
    key: 'dark',
    label: 'Dark',
    bg: '#0f172a',
    text: '#f1f5f9',
    accent: '#818cf8',
    secondary: '#94a3b8',
    border: '#1e293b',
    topicColor: '#c7d2fe',
    tagBg: '#1e293b',
    swatch: ['#0f172a', '#818cf8'],
  },
  {
    key: 'scripture',
    label: 'Scripture',
    bg: '#fef3c7',
    text: '#451a03',
    accent: '#92400e',
    secondary: '#78350f',
    border: '#fbbf24',
    topicColor: '#7c2d12',
    tagBg: '#fde68a',
    swatch: ['#fef3c7', '#92400e'],
  },
  {
    key: 'ocean',
    label: 'Ocean',
    bg: '#0c4a6e',
    text: '#f0f9ff',
    accent: '#38bdf8',
    secondary: '#bae6fd',
    border: '#075985',
    topicColor: '#7dd3fc',
    tagBg: '#075985',
    swatch: ['#0c4a6e', '#38bdf8'],
  },
  {
    key: 'minimal',
    label: 'Minimal',
    bg: '#fafafa',
    text: '#18181b',
    accent: '#18181b',
    secondary: '#71717a',
    border: '#d4d4d8',
    topicColor: '#27272a',
    tagBg: '#f4f4f5',
    swatch: ['#fafafa', '#18181b'],
  },
];

/** Convenience: pick a theme by key (falls back to the first). */
export const getShareTheme = (key) =>
  SHARE_THEMES.find((t) => t.key === key) || SHARE_THEMES[0];
